import {Country, CountryType, Region, SiteAdapter} from '@spartacus/core';
import { Observable } from 'rxjs';

export abstract class CustomSiteAdapter extends SiteAdapter {
  /**
   * Abstract method used to get all countries from all basestores with optional type.
   */
  abstract loadCountriesAll(type?: CountryType): Observable<Country[]>;

  /**
   * Abstract method used to get regions for a country and delivery zone.
   */
  abstract loadRegionsByZone(countryIsoCode: string, zone?: string): Observable<Region[]>;

}
